















































import {Component} from "vue-property-decorator";
import routenames from "@/modules/vRoutedefs";
import CommonBase from "../../CommonBase";
import {CanonicalHost} from "@/modules/constants";

@Component
export default class AdminIntro extends CommonBase {
    rn = routenames;

    readonly canonicalHost = CanonicalHost;

    showInfo = false;
}
